import brand1 from 'assets/images/development/brand-1.png'
import brand2 from 'assets/images/development/brand-2.png'
import brand3 from 'assets/images/development/brand-3.png'
import brand4 from 'assets/images/development/brand-4.png'
import heroImage from 'assets/images/development/hero.png'
import mbr1 from 'assets/images/development/mbr-1.png'
import mbr2 from 'assets/images/development/mbr-2.png'
import mbr3 from 'assets/images/development/mbr-3.png'
import people1 from 'assets/images/development/people-1.png'
import people2 from 'assets/images/development/people-2.png'
import people3 from 'assets/images/development/people-3.png'
import people4 from 'assets/images/development/people-4.png'
import product1 from 'assets/images/development/product-1.png'
import product2 from 'assets/images/development/product-2.png'
import product3 from 'assets/images/development/product-3.png'
import product4 from 'assets/images/development/product-4.png'

export { heroImage }

export const muralLink =
  'https://app.mural.co/t/reborrn0190/m/reborrn0190/1741803875130/917b26cb6886cf897e1b7145046bcdb99e8249d8?sender=u63412ace9107fd7363ca8493'

export const developmentIntroParagraphs = [
  'The Development phase is where the three workstreams — People, Product, and Brand — come together to transform insights into a Meaningful Brand Role.',
  'This stage turns the assessment and insight work into a cohesive Brand Vision Architecture, guided by a clear, standardized yet flexible framework.',
  'Based on the Working Mode selected on stage 3 (Async Exploration with Moment of Fusion VS End-to-End Co-Creation), the BVA 2.0 Process offers two structured but flexible pathways for development, allowing teams to adapt based on time, scope, and maturity of the brand.',
  'Regardless of which option you choose, at the end of this phase you should have 16 templates completed, which should all be filled directly on this Mural.',
]

export interface DevelopmentCard {
  title: string
  image: string
}

export interface DevelopmentSection {
  key: 'people' | 'product' | 'brand' | 'meaningful-brand-role'
  title: string
  variant: 'people' | 'product' | 'brand' | 'gradient'
  cards: DevelopmentCard[]
}

export const developmentSections: DevelopmentSection[] = [
  {
    key: 'people',
    title: 'People',
    variant: 'people',
    cards: [
      { title: 'Through the Eyes of Our Consumer', image: people1 },
      { title: 'How They Use the Category', image: people2 },
      { title: 'Surfacing Tensions', image: people3 },
      { title: 'Shortlist', image: people4 },
    ],
  },
  {
    key: 'product',
    title: 'Product',
    variant: 'product',
    cards: [
      { title: 'Capturing AHAs', image: product1 },
      { title: 'Us vs Category', image: product2 },
      { title: 'Shortlist', image: product3 },
      { title: 'Products Edge', image: product4 },
    ],
  },
  {
    key: 'brand',
    title: 'Brand',
    variant: 'brand',
    cards: [
      { title: 'Capturing AHAs', image: brand1 },
      { title: 'Us vs Competition', image: brand2 },
      { title: 'Shortlist', image: brand3 },
      { title: 'Brand Edge', image: brand4 },
    ],
  },
  {
    key: 'meaningful-brand-role',
    title: 'Meaningful Brand Role',
    variant: 'gradient',
    cards: [
      { title: 'Building Relevance', image: mbr1 },
      { title: 'Our Vow to Our Consumers', image: mbr2 },
      { title: 'Mini Manifesto', image: mbr3 },
      { title: 'BVA Framework', image: heroImage },
    ],
  },
]
